import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('api_url');
export const FSM_API_URL = new InjectionToken<string>('fsm_api_url');
